"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
/**
 * Created by aghavni.grigoryan on 10/10/2017.
 */
class BaseExportMenu {
    constructor() {
        // In case message with appropriate key exists, export 3dot button will be replaced with mentioned message button
        this.exportButtonLabel = 'reporting.controls.control-export.button.label';
    }
    /**
     * These method calls every time when some export type was selected, and it emit selected export time out.
     * @param exportType
     */
    exportReport(exportType) {
        this.export.emit(exportType);
    }
}
__decorate([
    core_1.Output("exportEmitter"),
    __metadata("design:type", core_1.EventEmitter)
], BaseExportMenu.prototype, "export", void 0);
exports.BaseExportMenu = BaseExportMenu;
//# sourceMappingURL=base-export-menu.js.map